// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lA_R7 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.zWVMS {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.hT005 {
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.GGkn8 {
    opacity: 1;
}

.g192B {
    width: 80vw;
    height: 80vh;
    border-radius: 26px;
    z-index: 1000;
    position: relative;
    overflow: auto;
}

.O836e {
    opacity: 0;
    transform: scale(0);
}

.xdGpW {
    opacity: 1;
    transform: scale(1.05);
    transition: opacity 0.15s ease-out, transform 0.15s ease-out;
}

.Pkv_I {
    opacity: 1;
    transform: scale(1);
    transition: transform 0.1s ease-out;
}

.CJTfK {
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.15s ease-in, transform 0.15s ease-in;
}

.JBqeJ {
    position: absolute;
    top: -38px;
    right: -38px;
    z-index: 1001;
    width: 76px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 38px;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/Modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,4DAA4D;AAChE;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.backdropContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.backdrop {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n}\n\n.backdropVisible {\n    opacity: 1;\n}\n\n.modalContainer {\n    width: 80vw;\n    height: 80vh;\n    border-radius: 26px;\n    z-index: 1000;\n    position: relative;\n    overflow: auto;\n}\n\n.modalInitial {\n    opacity: 0;\n    transform: scale(0);\n}\n\n.modalEntering {\n    opacity: 1;\n    transform: scale(1.05);\n    transition: opacity 0.15s ease-out, transform 0.15s ease-out;\n}\n\n.modalVisible {\n    opacity: 1;\n    transform: scale(1);\n    transition: transform 0.1s ease-out;\n}\n\n.modalExiting {\n    opacity: 0;\n    transform: scale(0);\n    transition: opacity 0.15s ease-in, transform 0.15s ease-in;\n}\n\n.closeButton {\n    position: absolute;\n    top: -38px;\n    right: -38px;\n    z-index: 1001;\n    width: 76px;\n    height: 76px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `lA_R7`,
	"backdropContainer": `zWVMS`,
	"backdrop": `hT005`,
	"backdropVisible": `GGkn8`,
	"modalContainer": `g192B`,
	"modalInitial": `O836e`,
	"modalEntering": `xdGpW`,
	"modalVisible": `Pkv_I`,
	"modalExiting": `CJTfK`,
	"closeButton": `JBqeJ`
};
export default ___CSS_LOADER_EXPORT___;
